import * as go from 'gojs';

export enum Easing {
  Linear,
  InQuad,
  OutQuad,
  InOutQuad,
  InExpo,
  OutExpo,
}

export const easingMapping = {
  [Easing.Linear]: go.Animation.EaseLinear,
  [Easing.InQuad]: go.Animation.EaseInQuad,
  [Easing.OutQuad]: go.Animation.EaseOutQuad,
  [Easing.InOutQuad]: go.Animation.EaseInOutQuad,
  [Easing.InExpo]: go.Animation.EaseInExpo,
  [Easing.OutExpo]: go.Animation.EaseOutExpo,
};
